module.exports = __webpack_public_path__ + "assets/images/user-placeholder.25hbd-9304aeb17e1c41f8162b754664b01222.jpg";